import React 		from 'react'
import classnames 	from 'classnames'
import { connect } 	from 'react-redux'

import ARYImage 		from '../ary-image'
import ParallaxEl 		from '../parallax-el'

class BGImage extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			screenSize,
			margin,
			children
		} = this.props

		const _margin = margin ? screenSize.height * -0.1 : 0

		return <div className="bg-el"
			style={{
				top: _margin,
				bottom: _margin
			}}>
			{ children }
		</div>
	}
}

const mapStateToProps = (state) => {
	const {
		ui
	} = state

    return {
    	screenSize: ui.screenSize
    }
}

export default connect(mapStateToProps, null)(BGImage)